{
  "count": "{filled} of {total}"
}
